"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var layout_1 = require("../../_shared/components/layout");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var index_1 = require("../../_shared/components/inputs/index");
var FormComponent_1 = require("../../_shared/components/inputs/FormComponent");
require("./LoginForm.scss");
var reducers_1 = require("../../_shared/reducers");
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { name: '', password: '', error: '' };
        return _this;
    }
    LoginForm.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.authenticate.token) {
            this.setState({ error: '' });
            this.props.history.push('dashboard');
            return;
        }
        this.setState({ error: newProps.loginApi.errorMessage || '' });
    };
    LoginForm.prototype.onLogin = function () {
        this.props.login(this.state.name, this.state.password);
    };
    LoginForm.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { id: "login-form" },
            React.createElement(index_1.Form, { onSubmit: function () { return _this.onLogin(); } },
                React.createElement("div", { className: "mobile-input-border" },
                    React.createElement(layout_1.Row, null,
                        React.createElement("i", { className: "material-icons icon" }, "perm_identity"),
                        React.createElement("input", { className: "mobile-input", value: this.state.name, onChange: function (e) { return _this.handleInputChange(e); }, placeholder: "Username", name: "name", type: "text", autoComplete: "off", required: true }))),
                React.createElement(layout_1.Margin, { marginVertical: "24px" }),
                React.createElement("div", { className: "mobile-input-border" },
                    React.createElement(layout_1.Row, null,
                        React.createElement("i", { className: "material-icons icon" }, "lock"),
                        React.createElement("input", { className: "mobile-input", value: this.state.password, onChange: function (e) { return _this.handleInputChange(e); }, placeholder: "Password", name: "password", autoComplete: "off", required: true, type: "password" }))),
                React.createElement("div", { className: "margin-8" }),
                React.createElement(layout_1.Margin, { margin: "32px" }),
                React.createElement("div", { className: "center" },
                    React.createElement(layout_1.Row, { justifyContent: "center" },
                        React.createElement("input", { type: "submit", value: "Inloggen", className: "button button-login button-md" }))),
                React.createElement("div", { className: "margin-8" }),
                React.createElement(layout_1.Row, { justifyContent: "flex-start" },
                    React.createElement("span", { className: "error" }, this.state.error)))));
    };
    return LoginForm;
}(FormComponent_1.default));
// const mapStateToProps = (_: AppState, ownProps: MapModalOwnProps) => ({ });
var mapStateToProps = function (_) {
    return {
        authenticate: _.reducer.authentication,
        loginApi: _.reducer.api.login,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        login: function (username, password) { return reducers_1.LoginActions.authenticate({ username: username, password: password })(dispatch); },
    };
};
var Container = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(LoginForm);
exports.default = (0, react_router_1.withRouter)(Container);
